import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperReviews = () => {
  new Swiper('.swiper-reviews', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.05,
        spaceBetween: 10,
      },
      1440: {
        slidesPerView: 3.17,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperReviews;
